import React, { Component } from "react";
import {
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from "@material-ui/core";
import { Card } from "react-bootstrap";
import EContentDescription from "./EContentDescription";
import { RightCircleOutlined } from "@ant-design/icons";


const list = [
  {
    title: "Class Notes",
    link: "/e-content/class_note",
  },
  {
    title: "Class Videos",
    link: "/e-content/class_videos",
  },
  {
    title: "Assignments",
    link: "/e-content/class_assignments",
  },
  {
    title: "Classnote Requisitions",
    link: "/e-content/class_note_requisition",
  },
  
];

class EContent extends Component {
  state = {
    link: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  getLastLink = (link) => {
    let ll = link.split('/');
    if(ll.length > 0){
      return ll[ll.length - 1]
    }else{
      return '';
    }
  }

  render() {
    return (
      <div>
      
        <Container className="mb-4" style={{minHeight: '500px'}}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{ paddingTop: "5em" }}
            >
               <Card
                style={{
                  boxShadow: "none",
                  position: "stickey !important",
                  top: "0 !important",
                  // backgroundColor: '#EBDB86',
                  // border: `solid 2px #808080`
                }}
              >
                <div
                  style={{
                    boxShadow: "none",
                    position: "stickey",
                    top: "0",
                  }}
                >
                  <List component="nav">
                    {list.map((el, index) => (
                      <ListItem
                        button
                        style={{
                          borderBottom: "1px solid #0002",
                          marginBottom: "2px",
                        }}
                        key={index}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <div
                          style={{
                            fontSize: "1.5em",
                            fontWeight: "300",
                            padding: "0",
                          }}
                        >
                          {el.title}
                        </div>
                      </ListItem>
                    ))}
                  </List>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9}>
            <div style={{padding: 10}}>
              <EContentDescription type={this.state.link} />
              </div>
            </Grid>
            
          </Grid>
        </Container>
      </div>
    );
  }
}

export default EContent;
